import React, { useEffect } from 'react';
import { useProgress } from '@react-three/drei';
import './LoadingScreen.css';

/**
 * Full‑viewport overlay while any THREE assets are still loading.
 * Automatically disappears (via parent callback) when nothing is left to load.
 */
export default function LoadingScreen({ onLoaded }) {
  const { active, progress } = useProgress(); // global THREE.LoadingManager

  /* Tell parent we’re done once nothing is pending */
  useEffect(() => {
    if (!active) onLoaded?.();
  }, [active, onLoaded]);

  return (
    <div className="loading-screen">
      <div className="loading-screen__box">
        <div className="loading-screen__spinner" />
        <p>Loading&nbsp;{Math.floor(progress)}%</p>
      </div>
    </div>
  );
}
